<template>
    <div class="order-list record-detail order-help">
        <navigation-bar Close/>
        <div class="main">
            <delivery-info v-if="deliveryInfoRefresh" :id="id"></delivery-info>
            <div class="shadow-block">
                <el-button v-if="canEdit" @click="editOrder()">我想修改訂單</el-button>
                <el-button v-if="canCancel" @click="$router.push({name: 'OrderCancel', params:{id: id, takeoutStatus: takeoutStatus}})">取消訂單</el-button>
                <span v-if="!canEdit && !canCancel && (takeoutStatus === 1 || takeoutStatus === 2 || takeoutStatus === 3)">店家已接單，無法取消或修改，若有任何問題請撥打店家聯絡電話。</span>
            </div>
        </div>

    </div>
</template>

<script>
    import DeliveryInfo from '@/views/order/components/DeliveryInfo'
    export default {
        name: "OrderHelp",
        components: {
            DeliveryInfo,//餐點進度資訊
        },
        data() {
            return {
                id: typeof this.$route.query.i === "undefined" ? 0 : Number(this.$route.query.i),
                storeId: 0,
                takeoutStatus: -1,
                paymentMethodId: -1,
                canEdit: false,
                canCancel: false,
                deliveryInfoRefresh: false,
                isHasRewardPoint: false,
            }
        },
        created() {
          this.setupData()
        },
        mounted() {

        },
        methods: {
          setupData() {
            this.$http.fetchWithAuth`GetTakeoutOrder${{
              'id': this.id,
            }}
              ${json => {
              if (json.status) {
                this.storeId = json.data.storeId
                this.takeoutStatus = json.data.status
                this.paymentMethodId = json.data.paymentMethodId
                this.isHasRewardPoint = json.data.isHasRewardPoint

                if (this.takeoutStatus === 0 && this.paymentMethodId === 0) {
                  //先一率不能編輯避免衍生問題
                  this.canEdit = false
                } else {
                  this.canEdit = false
                }

                if (this.takeoutStatus === 0 || (this.paymentMethodId > 0 && (this.takeoutStatus === 1 || this.takeoutStatus === 2 || this.takeoutStatus === 3))) {
                  this.canCancel = true
                } else {
                  this.canCancel = false
                }

                this.deliveryInfoRefresh = true
              } else {
                this.$public.showNotify(json.message, json.status);
              }
            }}`;
          },
          editOrder() {
              if(this.isHasRewardPoint) {
                  this.$public.showNotify("因有使用到紅利點數，暫不提供修改訂單，請取消訂單後重新下訂", false);
              } else {
                  this.$store.commit("clearCartPageSnapshot");
                  this.$router.push({name: 'OrderCart', query: {takeoutId: this.id, storeId: this.storeId}})
              }
          }
        },
        watch: {
          '$store.state.changePageData.isChangePage': function() {
            if(this.$store.state.changePageData.isChangePage) {
              if (parseInt(this.$store.state.changePageData.takeoutId) === this.id) {
                this.deliveryInfoRefresh = false
                this.setupData()
              }

              this.$store.commit('setChangePageData',{
                isChangePage: false,
              });
            }
          }
        }
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
